<template>
  <div class="page-wrapper">
    <card class="card-centered">
      <p><img src="/img/cyto-logo.png"></p>
      <p>You are being logged out...</p>
    </card>
  </div>
</template>
<script>
import { firebase } from '../services/FirebaseService';

export default {
  mounted() {
    firebase.auth.signOut();
  },
};
</script>
<style>
.page-wrapper {
  display: flex;
  height: 100%;
  width: 100%;
  position: absolute;
  background: rgba(203, 203, 210, .15);
}

.card-centered {
  display: flex;
  padding: 30px 10px;
  align-items: center;
  text-align: center;
  margin: auto;
  width: 260px;
}
</style>
